import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2559ca68"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("支付状态：")
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 7,
  class: "btn_box"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("投诉详情")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("订单详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "投诉管理",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "dashed",
          onClick: _ctx.resetSearch
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'user')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(text?.nickname), 1),
              _hoisted_2,
              _createTextVNode(_toDisplayString(text?.mobile), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'courier')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(text?.name), 1),
              _hoisted_3,
              _createTextVNode(_toDisplayString(text?.phone), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'mode')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 2,
              color: _ctx.getOrderMode(text)?.color || ''
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getOrderMode(text)?.name || ''), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 3,
              color: _ctx.getLogisticsOrderStatus(text)?.color
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.getLogisticsOrderStatus(text)?.name), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          : _createCommentVNode("", true),
        (column.key === 'money')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("div", _hoisted_4, "运费：" + _toDisplayString(text), 1),
              _createElementVNode("div", _hoisted_5, "代收尾款：" + _toDisplayString(record.charges), 1),
              _createElementVNode("div", _hoisted_6, "优惠金额：" + _toDisplayString(record.discount_amount), 1),
              _createElementVNode("div", _hoisted_7, "付款金额：" + _toDisplayString(record.pay_amount), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'pay_status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              _createElementVNode("div", null, [
                _hoisted_8,
                _createVNode(_component_a_tag, {
                  color: _ctx.getPayStatus(text)?.color
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getPayStatus(text)?.name || ''), 1)
                  ]),
                  _: 2
                }, 1032, ["color"])
              ]),
              _createElementVNode("div", null, "支付方式：" + _toDisplayString(_ctx.getPayMethod(record.payment_method)?.name || ''), 1),
              (text > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, "支付时间：" + _toDisplayString(record.pay_time), 1))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'rob_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              _createElementVNode("div", null, "接单时间：" + _toDisplayString(text ? _ctx.dateFormat(text * 1000) : ''), 1),
              _createElementVNode("div", null, "寄件开始：" + _toDisplayString(record.ship_start_time), 1),
              _createElementVNode("div", null, "寄件结束：" + _toDisplayString(record.ship_start_time), 1),
              _createElementVNode("div", null, "寄件方式：" + _toDisplayString(_ctx.getShipMethod(record.ship_type)?.name || ''), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_a_button, {
                size: "small",
                class: "btn",
                onClick: ($event: any) => (_ctx.goDetail(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_button, {
                size: "small",
                class: "btn",
                onClick: ($event: any) => (_ctx.goDetail(record, 'order'))
              }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ], 64))
}